import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "form-close" }
const _hoisted_3 = { style: {"display":"flex","flex-wrap":"wrap"} }
const _hoisted_4 = { class: "full-table" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "form-wrapper slide-up"
}
const _hoisted_10 = { class: "form-close" }
const _hoisted_11 = {
  key: 0,
  style: {"margin-bottom":"15px"}
}
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 0,
  style: {"margin-bottom":"10px"}
}
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 1,
  style: {"margin-bottom":"10px"}
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["href"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { key: 2 }
const _hoisted_21 = ["src"]
const _hoisted_22 = { key: 3 }
const _hoisted_23 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loaded && !_ctx.showSub)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "form-wrapper slide-up",
          style: _normalizeStyle(_ctx.resendLoading ? 'width:800px;opacity: .5;pointer-events:none' : 'width:800px')
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              title: "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, "×")
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.formToView.AdminContinueSubmissionFormID)
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 0,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.finished) = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search())),
                  style: {"margin-right":"10px","width":"120px"}
                }, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("option", { value: false }, "Unfinished", -1),
                  _createElementVNode("option", { value: true }, "Finished", -1)
                ]))], 544)), [
                  [_vModelSelect, _ctx.finished]
                ])
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchQ) = $event)),
              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.search())),
              placeholder: "Search",
              style: {"width":"180px"}
            }, null, 544), [
              [_vModelText, _ctx.searchQ]
            ])
          ]),
          _createElementVNode("table", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.submissions, (sub, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, _toDisplayString(sub.CreatedDisplay), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    onClick: _withModifiers(($event: any) => (_ctx.viewSub(sub)), ["prevent"])
                  }, _toDisplayString(sub.SignatureDisplay), 9, _hoisted_5)
                ]),
                (_ctx.formToView.AdminContinueSubmissionFormID)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                      _createElementVNode("a", {
                        href: `/team-hub?formID=${_ctx.formToView.AdminContinueSubmissionFormID}&previousSubmissionID=${sub.ID}`,
                        target: "_blank"
                      }, "Finish", 8, _hoisted_7)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    onClick: _withModifiers(($event: any) => (_ctx.resendSub(sub)), ["prevent"])
                  }, "Resend Email", 8, _hoisted_8)
                ])
              ]))
            }), 128))
          ])
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.showSub)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              title: "Close",
              onClick: _cache[5] || (_cache[5] = () => { _ctx.showSub = false })
            }, "×")
          ]),
          (_ctx.formToView.AdminContinueSubmissionFormID)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("a", {
                  href: `/team-hub?formID=${_ctx.formToView.AdminContinueSubmissionFormID}&previousSubmissionID=${_ctx.subToShow.id}`,
                  target: "_blank",
                  class: "primary",
                  style: {"font-weight":"bold"}
                }, "Finish", 8, _hoisted_12)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subToShow.fields, (field, i) => {
            return (_openBlock(), _createElementBlock("div", { key: i }, [
              (field.type == 'multiplefiles' && field.values?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", null, [
                      _createElementVNode("b", null, _toDisplayString(field.label) + ":", 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.values, (url, n) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i + '_' + n
                      }, [
                        _createElementVNode("a", {
                          href: url,
                          target: "_blank"
                        }, "Download File", 8, _hoisted_14)
                      ]))
                    }), 128))
                  ]))
                : (field.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (field.type == 'file')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("div", null, [
                              _createElementVNode("b", null, _toDisplayString(field.label) + ":", 1),
                              _cache[7] || (_cache[7] = _createTextVNode()),
                              _createElementVNode("a", {
                                href: field.value,
                                target: "_blank"
                              }, "Download File", 8, _hoisted_17)
                            ])
                          ]))
                        : (field.type == 'textarea')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createElementVNode("b", null, _toDisplayString(field.label) + ":", 1),
                              _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("div", {
                                innerHTML: field.value.replace(/\n/g, '<br/>')
                              }, null, 8, _hoisted_19)
                            ]))
                          : (field.type == 'signature')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("b", null, _toDisplayString(field.label) + ":", 1)
                                ]),
                                _createElementVNode("img", {
                                  src: field.value
                                }, null, 8, _hoisted_21)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("b", null, _toDisplayString(field.label) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(field.value), 1)
                              ]))
                    ]))
                  : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createElementVNode("div", null, [
            _cache[9] || (_cache[9] = _createElementVNode("div", null, [
              _createElementVNode("b", null, "Signature:")
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: _ctx.subToShow.signatureData
              }, null, 8, _hoisted_23)
            ]),
            _createElementVNode("div", null, _toDisplayString(_ctx.subToShow.signature), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}